'use client'

import { PDFDownloadLink, PDFViewer } from '@react-pdf/renderer';
import DestinationPdf from './DestinationPdf';
const DestinationWeddingQuotationPdf = ({ pdfData }) => {
  const fileName = "DestinationWeddingQuotation.pdf";
  return (
    <div>
      {/* <PDFViewer width={800} height={500} showToolbar={false}>
        <PdfDocument pdfData={pdfData} />
      </PDFViewer> */}
      <div className='download-link'>
        <PDFDownloadLink
          document={<DestinationPdf pdfData={pdfData} />}
          fileName={fileName}
          style={{ color: "#fff", textDecoration: "none" }}
        >
          <center>
            <button className='btn btn-success text-white my-3'>
              Download Destination Quotation
            </button>
          </center>
        </PDFDownloadLink>
      </div>
    </div>
  )
}

export default DestinationWeddingQuotationPdf